// extracted by mini-css-extract-plugin
export default {"timeForm__verdict":"styles_timeForm__verdict__JIbpq","timeForm__logo":"styles_timeForm__logo__1Srhf"};